/**
 * サムネイル付きスライダー
 * メインスライダーとサムネイルスライダーを同期
 * @see https://splidejs.com/tutorials/thumbnail-carousel/
 */

import "@splidejs/splide/dist/css/splide-core.min.css";
import { Splide } from "@splidejs/splide";

const aboutActivitySplideElement = document.getElementById("js-splide-about-activity");

if (aboutActivitySplideElement) {
  
  const aboutActivitySplide = new Splide(aboutActivitySplideElement, {
    type: "loop",
    // autoplay: true, // 自動再生
    // isNavigation: true, // ナビゲーションとして機能させるにはこのコメントアウトを外す
    autoWidth: true,
    gap: "calc(41 / 16 * 1rem)",
    pagination: false,
    breakpoints: {
      768: {
        focus: "center",
        gap: "calc(24 / 16 * 1rem)",
      },
    },
  });

  aboutActivitySplide.mount();
}


